/**
 * Rollen und Rechte: rein informative Übersicht für den Schul-Admin.
 *
 * Die Rechte sind fest vergeben und nicht konfigurierbar. Verbindlich durchgesetzt
 * werden sie im Backend (writeAccessMiddleware in backend/src/auth.ts sowie
 * schulAdminMiddleware). Der Dialog dokumentiert nur, was welche Rolle darf, und
 * haengt deshalb am Info-Button der Benutzer-Seite, wo die Rollen vergeben werden.
 */
import { openModal, closeModal, modalBody } from "./modal";

type Area = { label: string; admin: string; koordinator: string; viewer: string };

const AREAS: Area[] = [
  { label: "Klassen", admin: "Bearbeiten", koordinator: "Bearbeiten", viewer: "Nur lesen" },
  { label: "Schüler", admin: "Bearbeiten", koordinator: "Bearbeiten", viewer: "Nur lesen" },
  { label: "Praktikumsstellen", admin: "Bearbeiten", koordinator: "Bearbeiten", viewer: "Nur lesen" },
  { label: "Karte", admin: "Ansehen", koordinator: "Ansehen", viewer: "Ansehen" },
  { label: "Planung", admin: "Bearbeiten", koordinator: "Bearbeiten", viewer: "Nur lesen" },
  { label: "Dokumente je Schüler und Praktikumsstelle", admin: "Hochladen und löschen", koordinator: "Hochladen und löschen", viewer: "Herunterladen" },
  { label: "Exporte (Excel und PDF)", admin: "Ja", koordinator: "Ja", viewer: "Ja" },
  { label: "Benutzerverwaltung", admin: "Ja", koordinator: "Kein Zugriff", viewer: "Kein Zugriff" },
  { label: "Einstellungen", admin: "Ja", koordinator: "Kein Zugriff", viewer: "Kein Zugriff" },
  { label: "Dokumente verteilen", admin: "Ja", koordinator: "Kein Zugriff", viewer: "Kein Zugriff" },
  { label: "Abonnements", admin: "Ja", koordinator: "Kein Zugriff", viewer: "Kein Zugriff" },
];

function cell(value: string): string {
  const muted = value === "Kein Zugriff";
  return `<td style="${muted ? "color:var(--gray-400)" : ""}">${value}</td>`;
}

/** Zeigt die Rechte-Matrix als Dialog; wird vom Info-Button auf der Benutzer-Seite aufgerufen. */
export function openRolesInfoModal() {
  openModal("Rollen und Rechte", `
    <p style="color:var(--gray-600);font-size:.9rem;max-width:60ch;margin-top:0">
      Jeder Benutzer bekommt genau eine Rolle. Die Rechte sind fest vergeben und
      lassen sich nicht einzeln einstellen.
    </p>
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Bereich</th>
            <th>Schul-Admin</th>
            <th>Koordinator</th>
            <th>Betrachter</th>
          </tr>
        </thead>
        <tbody>
          ${AREAS.map(a => `
            <tr>
              <td style="font-weight:500">${a.label}</td>
              ${cell(a.admin)}
              ${cell(a.koordinator)}
              ${cell(a.viewer)}
            </tr>`).join("")}
        </tbody>
      </table>
    </div>
    <p style="color:var(--gray-500);font-size:.8125rem">
      Der Bereich Planung setzt zusätzlich das freigeschaltete Planungs-Tool voraus.
    </p>
    <div class="form-actions"><button class="btn btn-primary" id="roles-close">Schließen</button></div>`, { wide: true });

  modalBody().querySelector("#roles-close")!.addEventListener("click", closeModal);
}
